import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { BouncingLoader } from '../../pure-components/Loader';

import { ReactComponent as Logo } from "../../assets/logo-day.svg";
import { ErrorToast, SuccessToast } from '../../pure-components/CustomToast';
import { toast } from 'react-toastify';
import Constants from "../../services/constants";
import "./style.css";
import API from "../../services/api";
import Validator from "../../services/validator";
import Helper from "../../services/helper";
import CookieManager from "../../services/CookieManager";
export default function () {
    const validator = new Validator();
    
    const [helperText, setHelperText] = useState({});
    
    const {planType}=useParams();
    const userType = String(planType).toUpperCase() === "FREE" ? "FREE" : String(planType).toUpperCase() === "SOLO" ? "SOLO" : "SOLO_PRO";
    const [loadingProducts, setLoadingProducts] = useState(true);
    const [allProducts, setAllProducts] = useState(null);
    const [filteredProducts, setFilteredProducts] = useState(null);
    const [productSelectionList, setProductSelectionList] = useState(null);

    const [monthlyProductData, setMonthlyProductData] = useState(null);
    const [yearlyProductData, setYearlyProductData] = useState(null);
    const [selectedPlan, setSelectedPlan] = useState(null);
    
    const [OTP, setOTP] = useState(null);
    const [OTPVerified, setOTPVerified] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [paymentForm, setPaymentForm]  = useState("");

    // const [planType, setPlanType] = useState("Solo");


    const[modelData, setModelData] = useState(null);
    const [yearlyPlan, setYearlyPlan] = useState(true);
    const [plans, setPlans] = useState(null);
    const [popup, setPopup] = useState(false);
    const [GIFLink, setGIFLink] = useState(null);
    // const [loadingProducts, setLoadingProducts] = useState(true);
    // const [allProducts, setAllProducts] = useState(null);
    // const [costData, setCostData] = useState(null);
    const [costData, setCostData] = useState(null); 
    // useEffect(() => {
    //     console.log("monthly plan : ", yearlyPlan)
    // },[yearlyPlan])
    
    const actionType = {
        create : "create",
        edit : "edit"
    }

    const profileData = JSON.parse(CookieManager.getCookie("user-data") || "{}"); 
    const [action, setAction] = useState(profileData?.email?.length > 0 ? actionType.edit : actionType.create);
    const [subscribing, setSubscribing] = useState(false);
    const [userData, setUserData] = useState({
        email : profileData?.email || "",
        password : "",
        companyName : profileData?.companyName || "",
        country : profileData?.country || "IN",
        tos : false
    })
    useEffect(() =>{
        (async() => {
            await loadProducts();
        })()
    },[])
    
    useEffect(() => {
        if(planType?.length > 0 && allProducts?.length > 0){
            let tempData = [];
            let products = [];
            allProducts.forEach(elem => {
                if(elem?.type === String(planType)?.toUpperCase()){
                    tempData.push(elem);
                    if(userType==="FREE"){
                        setSelectedPlan(elem);
                        products.push(elem);
                    }else{
                        if(userData?.country && userData.country === elem?.nickName){
                            elem?.interval === "month" ? setMonthlyProductData(elem) : setYearlyProductData(elem);
                            setSelectedPlan(elem);
                            products.push(elem);
                        }
                    }
                }
            })
         
            setFilteredProducts(tempData);
            setProductSelectionList(products);
        }
        // console.log("product list : ", allProducts);

    }, [allProducts, planType])

    useEffect(()=> {
        // console.log("filterd products : ", filteredProducts);
    }, [filteredProducts])

    useEffect(()=> {
        // console.log("plan data : ", monthlyProductData, yearlyProductData, selectedPlan);
    }, [monthlyProductData, yearlyProductData])


    // useEffect(() => {
    //     if(pageModelData){
    //         pageModelData.plans = pageModelData.plans?.map(elem => {
    //             if(elem.id !== Constants.SUBSCRIPTION_TYPE.CORPORATE)
    //                 elem.link = elem.link.replace("$[BASE_URL]", process.env.REACT_APP_PUBLIC_URL + 'signup/');
    //             // else
    //             // elem.link = elem.link.replace("$[FORM_BASE_URL]", window.location.host);
                
    //             return elem;
    //         }) 
    //         setModelData(pageModelData);
    //         (async()=>{
    //             await loadProducts();
    //         })();
    //     }
    // },[])

    const loadProducts = async()=>{
        await API.getProductList().then((res) => {
            // console.log("loadProductsResp : ", res.data);
            setAllProducts(res.data);
            }).catch(err => {
              console.log("Products loading error : "+ err)
              toast(({ closeToast }) => <ErrorToast message={"Products loading error"} />);
            })
        setLoadingProducts(false);
    }

    const updatePlanData = (planCost)=>{
        if(!planCost)
            planCost = costData;
        let tempPlans = [];
        if(yearlyPlan)
            tempPlans = plans?.map(elem=>{
                if(elem.id === "SOLO")
                    elem.cost = parseInt(planCost?.solo.yearly / 12);
                if(elem.id === "PRO")
                    elem.cost = parseInt(planCost?.pro.yearly / 12);
                return elem;
            })
        else
            tempPlans = plans?.map(elem=>{
                if(elem.id === "SOLO")
                    elem.cost = parseInt(planCost?.solo.monthly);
                if(elem.id === "PRO")
                    elem.cost = parseInt(planCost?.pro.monthly);
                return elem;
            })
             
              
        setPlans(tempPlans);
    }
    useEffect(() => {
        if(modelData?.plans)
            setPlans(modelData.plans);
    }, [modelData])

    useEffect(()=>{
        if(plans?.length > 0 && costData)
            updatePlanData();
    },[yearlyPlan])

    useEffect(()=>{
        if(allProducts){
            let tempData = {solo:{monthly: 0, yearly: 0}, pro:{monthly: 0, yearly: 0}};
            for(const prod of allProducts){
                if(prod?.name?.indexOf("SOLO_PRO_") > -1){
                    if(prod?.name?.indexOf("_MONTHLY") > -1){
                        tempData.pro.monthly = parseFloat(prod.unit_amount_decimal)/100;
                    }else if(prod?.name?.indexOf("_YEARLY") > -1){
                        tempData.pro.yearly = parseFloat(prod.unit_amount_decimal)/100;
                    }
                }else if(prod?.name?.indexOf("SOLO_") > -1){
                    if(prod?.name?.indexOf("_MONTHLY") > -1){
                        tempData.solo.monthly = parseFloat(prod.unit_amount_decimal)/100;
                    }else if(prod?.name?.indexOf("_YEARLY") > -1){
                        tempData.solo.yearly = parseFloat(prod.unit_amount_decimal)/100;
                    }
                }
                 
            }
            
            // console.log("cost data ; ", tempData);
            setCostData(tempData);
            updatePlanData(tempData);
                     
        }
    },[allProducts])

    useEffect(()=>{
        if(costData && plans?.length > 0){
            updatePlanData();
        }
    },[costData])

    useEffect(() => {
        // console.log("userData : ", userData, helperText)
    }, [userData, userData.tos, helperText])

    const handleInputChange  = (e, key) => {
        let value = key === 'tos' ? e : e.target.value;
        if (key === 'email') {
          let res = validator.setValue(value, 'Email ').isNotEmpty().isEmail();
          let temp = {...helperText};
          temp[key] = res.mssg;
          setHelperText(temp);
        }
        if (key === 'password') {
          let res = validator.setValue(value, 'Password ').isNotEmpty().isString().checkPasswordStrength();
          let temp = {...helperText};
          temp[key] = res.mssg;
          setHelperText(temp);
        }
        // if(helperText['email']?.length > 0 || helperText['password']?.length > 0)
        //   setIsDisabled(true);
        // else
        //   setIsDisabled(false)
    
        let tempUserData = {...userData};
        tempUserData[key] = value;
        setUserData(tempUserData);
    }

    const handleCountryChange = (e) => {

        // console.log("event data : ", e, e.target.value);
        if(planType?.length > 0 && userType!=="FREE" && allProducts?.length > 0){
            setSelectedPlan(null);
            let products = [];
            allProducts.forEach(elem => {
                if(elem?.type === String(planType)?.toUpperCase()){
                    if(e.target.value && e.target.value === elem?.nickName){
                        elem?.interval === "month" ? setMonthlyProductData(elem) : setYearlyProductData(elem);
                        products.push(elem);
                    }
                }
            })
            setProductSelectionList(products);
        }
        setUserData({...userData, country: e.target.value});
    }

    const addSubscription = async() =>{
        setSubscribing(true);
        const tempData = {...userData, email : userData.email?.toLowerCase()};
        delete tempData.password;
        await API.addSubscription({...tempData, userType: userType, productId : selectedPlan.id, isEdited : action === actionType.edit ? true : false}).then((res) => {
            // console.log("signUp response : ", res.data);
            if(res.success){
                
                const msg = "Request processed, You will be redirected for payment.";
                toast(({ closeToast }) => <SuccessToast message={msg} />);
                
                if(res.data?.length > 0){
                    // setPaymentForm(res.data);
                    setTimeout(() => {
                        const formContainer = document.createElement('div');
                        formContainer.innerHTML = res.data;
                        document.body.appendChild(formContainer);
                        
                        const form = document.getElementById('paymentForm');
                        form.submit();
                    }, 3000)
                }
            
            }
            
            setSubscribing(false);
            }).catch(err => {
              console.log("Add subscription error : "+ err)
              toast(({ closeToast }) => <ErrorToast message={"Add subscription error." + err?.mssg} />);
            })
        setSubscribing(false)
    }

    const signUp = async() =>{
        setProcessing(true);
        userData.email = userData.email?.toLowerCase();
        await API.signUp({...userData, userType: userType, password : Helper.encode(userData.password)}).then((res) => {
            // console.log("signUp response : ", res.data);
            toast(({ closeToast }) => <SuccessToast message={"Verification code sent. Please check your email address."} />);
            setOTPVerified(false);
            }).catch(err => {
              console.log("User signup error : "+ err)
              toast(({ closeToast }) => <ErrorToast message={"User signup error." + err?.mssg} />);
            })
        setProcessing(false);
    }

    const verifyOTP = async() => {
        await API.verifyOTP({email : userData.email?.toLowerCase(), OTP : OTP, productId : selectedPlan.id}).then((res) => {
            // console.log("OTP verification response : ", res.data);
            if(res.success){
                
                const msg = userType!=="FREE" ? "Code verified. You will be redirected for payment." : "Code verified. Login to Continue."
                toast(({ closeToast }) => <SuccessToast message={msg} />);
                
                setOTPVerified(true);
                if(userType === "FREE"){
                    setTimeout(() => {window.location = '/login'}, 3000);
                }else{
                    if(res.data?.length > 0){
                        // setPaymentForm(res.data);
                        setTimeout(() => {
                            const formContainer = document.createElement('div');
                            formContainer.innerHTML = res.data;
                            document.body.appendChild(formContainer);
                            
                            const form = document.getElementById('paymentForm');
                            form.submit();
                        }, 3000)
                    }
                }

            }
            }).catch(err => {
              console.log("OTP verification error : "+ err)
              toast(({ closeToast }) => <ErrorToast message={"OTP verification error : " + err.mssg} />);
            })
    }

    const resendOTP = async() => {
        await API.resendOTP(userData.email?.toLowerCase()).then((res) => {
            // console.log("Resend OTP response : ", res.data);
            toast(({ closeToast }) => <SuccessToast message={"Verification code sent. Please check your email address."} />);
            }).catch(err => {
              console.log("Resend OTP error : "+ err)
              toast(({ closeToast }) => <ErrorToast message={"Resend OTP error."} />);
            })
    }

    const subscribe = async() =>{
        setProcessing(true);
        await API.subscribe({...userData, userType: userType, productId : selectedPlan.id, password : Helper.encode(userData.password)}).then((res) => {
            // console.log("signUp response : ", res.data);
            toast(({ closeToast }) => <SuccessToast message={"Verification code sent. Please check your email address."} />);
            setOTPVerified(false);
            }).catch(err => {
              console.log("User signup error : "+ err)
              toast(({ closeToast }) => <ErrorToast message={"User signup error." + err?.mssg} />);
            })
        setProcessing(false);
    }

    const sendOTPBtnDisabled = () =>{
        let disableButton = true;
        if(helperText?.email?.length === 0 && helperText?.password?.length === 0 && userData?.tos)
            disableButton = false;
        return disableButton;
    }

    const selectPlan = (plan) => {
        if(plan?.id === selectedPlan?.id){
            setSelectedPlan(null);
        }else{
            setSelectedPlan({...plan});
        }
    }

    const submitForm = () => {
        if (paymentForm) {
            const formElement = document.getElementById('paymentForm');
            // console.log("form : ", formElement);
            if (formElement) {
                formElement.submit();
            }
        }
    };

  return (
    <div className="w-full mt-10 lg:px-20 flex flex-wrap canvas">

        <div className="w-full justify-center flex">
            <div className="lg:w-1/2 sm:w-full flex flex-wrap mt-16 mb-10 rounded-2xl box" >
                <div className="w-full flex rounded-2xl">
                  <div className="w-full pl-12 my-2">
                    <div className="w-full py-4">
                        <span className="w-full flex header-text capitalize">
                            {planType}
                        </span>
                    </div>
                    <div className="w-full pb-2">
                        <span className="w-full flex field-title">
                            Email address
                        </span>
                        <span className="w-full flex">
                            <input
                                className={`w-11/12 self-center input-field rounded-full py-2` }
                                type="text"
                                placeholder="user@test.com"
                                value={userData.email}
                                onChange={(e) =>
                                    handleInputChange(e, "email")
                                }
                                readOnly={action === actionType.edit}
                            />
                        </span>
                        <span className="w-full flex">
                            <p className="helper-text-red pl-1">{helperText.email}</p>
                        </span>
                       
                    </div>

                    {action !== actionType.edit && 
                    <div className="w-full pb-2">
                        <span className="w-full flex field-title">
                            Password
                        </span>
                        <span className="w-full flex">
                            <input
                                className={`w-11/12 self-center input-field rounded-full py-2` }
                                type="password"
                                placeholder="Create a strong password"
                                value={userData.password}
                                onChange={(e) =>
                                    handleInputChange(e, "password")
                                }
                            />
                        </span>
                        <span className="w-full flex">
                            {helperText.password?.length > 0 ? <p className="helper-text-red pl-2">{helperText.password}</p> 
                              : <p className="helper-text pl-2">
                                    Minimum of 8 characters, with atleast 1 uppercase character, 1 lowercase character and 1 digit
                                </p>
                            }
                        </span>
                       
                    </div>}

                    <div className="w-full pb-2">
                        <span className="w-full flex field-title">
                            Business name
                        </span>
                        <span className="w-full flex">
                            <input
                                className={`w-11/12 self-center input-field rounded-full py-2` }
                                type="text"
                                placeholder="Your business name"
                                value={userData.companyName}
                                onChange={(e) =>
                                    handleInputChange(e, "companyName")
                                }
                            />
                        </span>
                        <span className="w-full flex">
                            <p className="helper-text-red pl-1">{helperText.companyName}</p>
                        </span>
                       
                    </div>
                    <div className="w-full pb-2">
                        <span className="w-full flex field-title">
                            Country
                        </span>
                        <span className="w-full flex">
                            <select
                                className="w-11/12 input-field"
                                name="Country"
                                id="Country"
                                value={userData.country}
                                onChange={(e) => {setProductSelectionList(null); handleCountryChange(e)}}
                            >
                                
                                {/* <option value="Language">Select your country</option> */}

                                {Constants.COUNTRIES.map((elem) => (
                                <option value={elem.code} key={elem.code}>{elem.label}</option>
                                ))}
                            </select>
                        </span>
                        <span className="w-full flex">
                            <p className="helper-text-red pl-1">{helperText.companyName}</p>
                        </span>
                       
                    </div>

                    {userType!=="FREE" &&<>
                    <div className="w-full">
                        <span className="w-full flex header-text">
                            Choose Your Plan
                        </span>
                    </div>
                    {productSelectionList?.length > 0 ?  
                    <>
                        <div className="w-full flex pb-4">
                            <div className={`w-full flex price-box rounded-2xl cursor-pointer ${monthlyProductData?.id === selectedPlan?.id && "selected-price-box"}`}
                            onClick={() => {selectPlan(monthlyProductData)}}>
                                <span className="" style={{width : "80%"}}>
                                    <p className="header-text">Monthly</p>
                                    <p className="field-title">₹{(monthlyProductData?.amount/100).toFixed(0)} + Tax</p>
                                    <p className="helper-text pt-4">Cancel anytime</p>
                                </span>
                                <span className="flex" style={{"width" : "20%", "justifyContent": "end", "alignItems": "center"}}>
                                    <input className="checkbox-round" checked={monthlyProductData?.id === selectedPlan?.id} type="checkbox" style={{"width": "2.0em", "height": "2.0em"}}/>
                                </span>
                            </div>
                            
                        </div>
                        <div className="w-full flex pb-6">
                            <div className={`w-full flex price-box rounded-2xl cursor-pointer ${yearlyProductData?.id === selectedPlan?.id && "selected-price-box"}`}
                            onClick={() => {selectPlan(yearlyProductData)}}>
                                <span className="" style={{width : "80%"}}>
                                    <p className="header-text">Yearly</p>
                                    <p className="field-title">₹{(yearlyProductData?.amount/1200).toFixed(0)} + Tax</p>
                                    <p className="helper-text pt-4">Save ₹{((monthlyProductData?.amount/100 - yearlyProductData?.amount/1200)*12).toFixed(0)} per year</p>
                                </span>
                                <span className="flex" style={{"width" : "20%", "justifyContent": "end", "alignItems": "center"}}>
                                    <input className="checkbox-round" checked={yearlyProductData?.id === selectedPlan?.id} type="checkbox" style={{"width": "2.0em", "height": "2.0em"}}/>
                                </span>
                            </div>
                            
                        </div>
                    </> : 
                    <div className="w-full flex justify-center pb-4 pr-16">
                        <BouncingLoader />
                    </div>}
                    </>}
                    <div className="w-full pb-2">
                        <span className="w-full flex title-text">
                            <input className="rounded-full checkbox-round mr-2" type="checkbox" 
                            checked={userData.tos} 
                            // value={userData.tos}
                            // onClick={(e) => handleInputChange(e, "tos")} 
                            onClick={() => {setUserData({...userData, tos : !userData.tos})}} 
                            />
                            <p className="pr-4">I agree to the <a className="link-text" target="_blank" href={`/terms`}>Terms of Service </a> and <a className="link-text" target="_blank" href={`/privacy`}>Privacy Policy</a></p>
                        </span>
                    </div>
                    {action === actionType.edit && userType!== "FREE" ?
                    <div className="w-full pb-2">
                        <span className="w-11/12 flex">
                            <button className={`${(!userData?.tos || subscribing || processing || (!selectedPlan)) ? "btn-disabled" : "btn-pink"}`} 
                            onClick={() => {addSubscription()}}
                            disabled={!userData?.tos || subscribing || processing || (!selectedPlan)}> Subscribe </button>
                        </span>
                    </div> : 
                    <>
                    <div className="w-full pb-2">
                        <span className="w-11/12 flex">
                            <button className={`${(sendOTPBtnDisabled() || processing || (userType!=="FREE" && !selectedPlan)) ? "btn-disabled" : "btn-pink"}`} 
                            onClick={() => {signUp()}}
                            disabled={sendOTPBtnDisabled() || processing || (userType!=="FREE" && !selectedPlan)}> Send OTP </button>
                        </span>
                    </div>
                    <div className="w-full pb-5">
                        <hr className="w-11/12 flex" />
                    </div>
                    <div className="w-full pb-4">
                        <span className="w-full flex title-text">
                            <p>We’ve sent a verification code to your email address</p>
                        </span>
                    </div>
                    <div className="w-full pb-2">
                        <span className="w-full flex sub-header-text pb-4">Enter OTP</span>
                        <span className="w-full flex">
                            <input
                                className={`w-11/12 self-center input-field rounded-full py-2` }
                                type="number"
                                placeholder="Enter OTP"
                                value={OTP}
                                onChange={(e) => setOTP(e.target.value)}
                            />
                        </span>
                    </div>
                    <div className="w-full pb-2">
                        <span className="w-full flex title-text pr-4">Did not receive the code? &nbsp;<p className="link-text" onClick={() => {resendOTP()}}> Resend</p></span>
                    </div>
                    <div className="w-full pb-2">
                        <span className="w-11/12 flex">
                            <button className={`${OTP?.length === 6 ? "btn-pink" : "btn-disabled"}`}  onClick={() => {verifyOTP()}}> Submit OTP </button>
                        </span>
                    </div>
                    </>}
                    {/* <div className="w-full pb-2">
                        <span className="w-11/12 flex justify-center">
                            Or
                        </span>
                    </div>
                    <div className="w-full pb-2">
                        <span className="w-11/12 flex">
                            <button className="btn" onClick={() => {verifyOTP()}}> Ĝ Sign up with Google </button>
                        </span>
                    </div> */}
                    {/* {paymentForm && (
                        <div>
                        <div
                            id="paymentFormContainer"
                            dangerouslySetInnerHTML={{ __html: paymentForm }}
                            // onLoad={() => {submitForm()}}
                        />
                        {submitForm()}
                        </div>
                    )} */}
                  </div>
                </div>
                {/* <div className="lg:w-1/2 sm:w-full flex rounded-2xl bg-gray-100">
                <div className="w-full flex flex-wrap pl-12 my-2">
                    <div className="w-full pt-8">
                        <span className="w-full flex header-text">
                            Choose Your Plan
                        </span>
                    </div>
                    {productSelectionList?.length > 0 ?  
                    <>
                        <div className="w-full flex pb-4">
                            <div className={`w-full flex plan-box rounded-2xl cursor-pointer ${monthlyProductData?.id === selectedPlan?.id && "selected-plan-box"}`}
                            onClick={() => {selectPlan(monthlyProductData)}}>
                                <span className="" style={{width : "80%"}}>
                                    <p className="header-text">Monthly</p>
                                    <p className="field-title">₹{(monthlyProductData?.amount/100).toFixed(0)} + Tax</p>
                                    <p className="helper-text pt-4">Cancel anytime</p>
                                </span>
                                <span className="flex" style={{"width" : "20%", "justifyContent": "end", "alignItems": "center"}}>
                                    <input className="checkbox-round" checked={monthlyProductData?.id === selectedPlan?.id} type="checkbox" style={{"width": "2.0em", "height": "2.0em"}}/>
                                </span>
                            </div>
                            
                        </div>
                        <div className="w-full flex pb-4">
                            <div className={`w-full flex plan-box rounded-2xl cursor-pointer ${yearlyProductData?.id === selectedPlan?.id && "selected-plan-box"}`}
                            onClick={() => {selectPlan(yearlyProductData)}}>
                                <span className="" style={{width : "80%"}}>
                                    <p className="header-text">Yearly</p>
                                    <p className="field-title">₹{(yearlyProductData?.amount/1200).toFixed(0)} + Tax</p>
                                    <p className="helper-text pt-4">Save ₹{((monthlyProductData?.amount/100 - yearlyProductData?.amount/1200)*12).toFixed(0)} per year</p>
                                </span>
                                <span className="flex" style={{"width" : "20%", "justifyContent": "end", "alignItems": "center"}}>
                                    <input className="checkbox-round" checked={yearlyProductData?.id === selectedPlan?.id} type="checkbox" style={{"width": "2.0em", "height": "2.0em"}}/>
                                </span>
                            </div>
                            
                        </div>
                    </> : 
                    <div className="w-full flex justify-center pb-4 pr-16">
                        <BouncingLoader />
                    </div>}

                    <div className="w-full pb-2">
                        <span className="w-11/12 flex">
                            <button className={`${selectedPlan && OTPVerified ? "btn-pink" : "btn-disabled"}`} 
                            onClick={() => {subscribe()}}> Subscribe </button>
                        </span>
                    </div>
                    <div className="w-full pb-5">
                        <hr className="w-11/12 flex" />
                    </div>
                    
                  </div>
               
                </div> */}
                
            </div>
      
        </div>
        
        <div className="w-full flex ml-4 sm:ml-0 justify-center">
            <Logo alt="brand-logo" />
        </div>
        <div className="m-4 w-full flex">
            <div className="w-full flex flex-wrap  gap-y-2 lg:gap-y-0 rounded-2xl px-4 md:px-10  lg:px-20 py-10 bg-black  sm:justify-center">
                <span className="w-1/2 md:w-1/3 lg:w-2/12 flex text-white justify-center">
                    <a className="w-full flex text-xs md:text-base justify-center" href={`/about`}>ABOUT US</a>
                </span>
                <span className="w-1/2 md:w-1/3 lg:w-2/12 flex text-white justify-center">
                    <a className="w-full flex text-xs md:text-base justify-center" href={`/terms`}>TERMS OF SERVICE</a>
                </span>
                <span className="w-1/2 md:w-1/3 lg:w-2/12 flex text-white justify-center">
                    <a className="w-full flex text-xs md:text-base justify-center" href={`/privacy`}>PRIVACY POLICY</a>
                </span>
                <span className="w-1/2 md:w-1/3 lg:w-2/12 flex text-white justify-center">
                    <a className="w-full flex text-xs md:text-base justify-center" href={`/cookies`}>COOKIE POLICY</a>
                </span>
                <span className="w-1/2 md:w-1/3 lg:w-2/12 flex text-white justify-center">
                    <a className="w-full flex text-xs md:text-base justify-center" href={`/faqs`}>FAQS</a>
                </span>
                <span className="w-1/2 md:w-1/3 lg:w-2/12 flex text-white justify-center">
                    <a className="w-full flex text-xs md:text-base justify-center" href={`/contact`}>CONTACT US</a>
                </span>
            </div>
        </div>
        <div className="w-full flex text-sm md:text-base justify-center mb-10">
            © {new Date().getFullYear()} SyncMama. All rights reserved.
        </div>
        
    </div>
  );
}
